export const generateExecScript = (execScript) => {
  const elem = document.createElement('script');
  elem.innerHTML = execScript;
  document.body.appendChild(elem);
};
